<ng-container *transloco="let t">
<div class="modal-header">
  <h4 class="modal-title">{{ t('portal.tasks.pdfPasswordRequired') }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>
<div class="modal-body">
  <p>{{ t('portal.tasks.pdfPasswordProtectedMessage', { fileName: file.name }) }}</p>
  <div class="mb-3">
    <label for="passwordInput" class="form-label">{{ t('portal.tasks.password') }}</label>
    <input
      type="password"
      id="passwordInput"
      class="form-control"
      [(ngModel)]="password"
      [placeholder]="t('portal.tasks.enterPassword')"
      autofocus
    />
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">{{ t('common.cancel') }}</button>
  <button type="button" class="btn btn-primary" (click)="submitPassword()">{{ t('common.submit') }}</button>
</div>
</ng-container>
